import { textAndImageBlock as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Our Leaders',
  image: 'image',
  title: 'Learn More',
  description: '#',
};

export default fakeProps(schema, TestData);
